<template>
  <v-card class="mb-4" :class="getSaleClass(sale)">
    <v-card-text class="pt-2">
      <v-row align="center">
        <!-- Selection Checkbox -->
        <v-col cols="auto">
          <v-checkbox
            :model-value="selected"
            @update:model-value="$emit('selection-changed', sale.ID)"
            hide-details
            density="compact"
          ></v-checkbox>
        </v-col>

        <!-- Sale Link -->
        <v-col cols="auto">
          <router-link
            :to="`/sales/${sale.ID}`"
            class="text-decoration-none"
          >
            {{ sale.ID }}
          </router-link>
        </v-col>

        <!-- Created Date -->
        <v-col cols="1">
        <span class="ml-1">{{ formatDate(sale.CreatedDate) }}</span>
        </v-col>

        <!-- Submit Date -->
        <v-col cols="1">
        <span class="ml-1">{{ formatDate(sale.submit_date) }}</span>
        </v-col>

        <!-- PO Number -->
        <v-col cols="2">
          <span class="ml-1">{{ sale.PONumber }}</span>
        </v-col>

        <!-- Vendor -->
        <v-col cols="2">
          <span class="ml-1">{{ sale.Vendor }}</span>
        </v-col>

        <!-- Item Number -->
        <v-col cols="3">
        <span class="ml-1">{{ sale.itemnumber }}</span>
        </v-col>

        <!-- Submitted Status -->
        <v-col cols="auto">
            <span class="ml-1">{{ sale.submitted }}</span>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <!-- Note -->
        <v-col cols="12" md="8">
          <v-text-field
            v-model="saleData.Note"
            label="Note"
            density="compact"
            hide-details
            @update:model-value="handleUpdate('Note')"
          ></v-text-field>
        </v-col>

        <!-- Send Message Button -->
        <v-col cols="12" md="4" class="d-flex align-center">
          <v-spacer></v-spacer>
          <v-btn 
            color="green"
            class="mr-2"
            @click="dialog = true"
          >
            Submit Tracking
          </v-btn>
          <v-btn
            color="primary"
            prepend-icon="mdi-message"
            @click="$emit('send-message', sale)"
          >
            Message
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-dialog v-model="dialog" width="500">
    <v-card>
        <v-card-title>Submit Tracking for {{ sale.ID }}</v-card-title>
      <v-card-text>
        <v-row>
            <v-col cols="12">
                <v-text-field v-model="trackingNumber" label="Tracking Number" density="compact" hide-details></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="trackingService" label="Tracking Service" density="compact" hide-details></v-text-field>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn color="green" @click="submitTracking" :loading="updating">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue'
import { salesService } from '@/services/salesService'
import { getSaleClass } from '@/utils/SaleClass'
import debounce from 'lodash/debounce'
import { formatDate as dateFormat } from '@/utils/helpers'

const props = defineProps({
  sale: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const dialog = ref(false)
const trackingNumber = ref(props.sale.trackingnumber)
const trackingService = ref(props.sale.ShippingService)
const updating = ref(false)

const emit = defineEmits(['selection-changed', 'update:sale', 'send-message'])

const saleData = ref({ ...props.sale })

const formatDate = (date) => {
  if (!date) return '—'
  return dateFormat(date)
}

const handleUpdate = debounce(async (field) => {
  try {
    await salesService.updateSale(props.sale.ID, saleData.value)
    emit('update:sale', { ...saleData.value })
  } catch (err) {
    console.error(`Error updating ${field}:`, err)
    // Revert to original value on error
    saleData.value[field] = props.sale[field]
  }
}, 500)

const submitTracking = async () => {
  updating.value = true
  try {
    await salesService.updateTracking(props.sale.ID, trackingNumber.value, trackingService.value)
    dialog.value = false
  } catch (err) {
    console.error('Error submitting tracking:', err)
  } finally {
    updating.value = false
  }
}

</script> 